import { getTokenDefinition, getTokens, } from "@bracket/chainography";
import type { ISwapProps, } from "./types";


export const SwapSliceDefaultprops: ISwapProps = {

	ready: false,
	fetching: false,
	mode: "REDEEM",

	tokenIn: getTokenDefinition({ symbol: "BRKTETH", chainId: 1, }),
	tokensIn: [getTokenDefinition({ symbol: "BRKTETH", chainId: 1, }),],
	redeemableTokens: [],
	preferredRedeemToken: getTokenDefinition({ symbol: "RSETH", chainId: 1, }),
	brokeTokens: [],
	amountIn: "0",
	inputBalance: "0",
	inputAllowance: BigInt(0),
	inputApproved: false,
	inputHasBalance: false,

	tokenOut: getTokenDefinition({ symbol: "RSETH", chainId: 1, }),
	tokensOut: [],
	amountOut: "0",
	outputBalance: "0",
	outputAllowance: BigInt(0),
	outputMaximum: BigInt(0),
	outputAvailable: false,

	swapValueUSD: "$0.00",
	transacting: false,
	quoting: false,
	quoted: false,
	quotedCallResult: null,
	impact: null,
	gas: null,
	minReceieved: -1,
	networkFee: -1,
	route: null,
	native: false,
	evaluation: "OK",
	minimumSwapBrkt: 0.01,
}
